import { buildResult, pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";

export default defineTest("transcription_jobs", "Transcription jobs", ({ transcription, fetchErrors }) => {
  if (fetchErrors.transcription) {
    return skip(`Transcription data unavailable: ${fetchErrors.transcription}`);
  }
  const jobs = Array.isArray(transcription) ? transcription : transcription ? [transcription] : [];
  if (jobs.length === 0) {
    return fail("No transcription jobs found for this patient");
  }
  const failed = jobs.filter(
    (j) => j.job_status && j.job_status !== "SUCCEEDED" && j.job_status !== "COMPLETED"
  );
  if (failed.length > 0) {
    return buildResult({
      warnings: [`${failed.length} job(s) with non-success status`],
      successes: [`${jobs.length} transcription job(s) found`],
      developerNotes: `Statuses: ${failed.map((j) => j.job_status).join(", ")}`,
    });
  }
  return pass(`${jobs.length} transcription job(s), all successful`);
});
